import { useMediaQuery } from '@mui/material';

export const useNumCols = () => {
  const xl = useMediaQuery('(min-width:900px)');
  const l = useMediaQuery('(min-width:600px)');
  const m = useMediaQuery('(min-width:350px)');

  return xl ? 4 : l ? 3 : m ? 2 : 1;
};
